import { PAGE_SIZE } from '~/constants';
import apiSSO from '~/utils/sso';
import { Access } from '~/types';
import { formatInTimeZone } from '~/utils/formatToTimeZone';
import { GetAccessReportResponse } from './types';

export async function getAccessReportsByUser(
  userId: string,
  page: number,
): Promise<GetAccessReportResponse> {
  const { data, headers } = await apiSSO.get<Access[]>(
    `/user/${userId}/hist/urls`,
    {
      params: {
        page,
        size: PAGE_SIZE,
      },
    },
  );

  const totalCount = Number(headers['x-total-count']);

  const results = data.map(access => ({
    ...access,
    formattedEntryDateTime: formatInTimeZone(
      access.dh_entradaurl,
      'dd-MM-yyyy kk:mm:ss xxx',
      'America/Sao_Paulo',
    ),
    formattedDepartureDateTime: formatInTimeZone(
      access.dh_saidaurl || access.dh_entradaurl,
      'dd-MM-yyyy kk:mm:ss xxx',
      'America/Sao_Paulo',
    ),
  }));

  return { totalCount, results };
}
